/**
 * @generated SignedSource<<66673a82f9f236934c9de01f47271903>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSeller_sellerStorefrontItems$data = {
  readonly items: ReadonlyArray<{
    readonly item: {
      readonly localizedPdpUrl: string | null;
      readonly photos: ReadonlyArray<{
        readonly smallPath: string | null;
      } | null> | null;
      readonly title: string | null;
    } | null;
  } | null> | null;
  readonly itemsAvailable: number | null;
  readonly " $fragmentType": "SbSharedRelatedSeller_sellerStorefrontItems";
};
export type SbSharedRelatedSeller_sellerStorefrontItems$key = {
  readonly " $data"?: SbSharedRelatedSeller_sellerStorefrontItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_sellerStorefrontItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSeller_sellerStorefrontItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchResult",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "localizedPdpUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 1
                }
              ],
              "concreteType": "ItemPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "smallPath",
                  "storageKey": null
                }
              ],
              "storageKey": "photos(limit:1)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RelatedSellersStorefrontItems",
  "abstractKey": null
};

(node as any).hash = "bb0237d019af16b3f06c08c6b5974028";

export default node;
